<script setup lang="ts">
import ToastStack from '@/components/ToastStack.vue';
</script>

<template>
  <router-view />
  <ToastStack />
</template>
